import { render, staticRenderFns } from "./Grails.vue?vue&type=template&id=aa0b6eca&scoped=true"
import script from "./Grails.vue?vue&type=script&lang=js"
export * from "./Grails.vue?vue&type=script&lang=js"
import style0 from "./Grails.vue?vue&type=style&index=0&id=aa0b6eca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0b6eca",
  null
  
)

export default component.exports